<form [formGroup]="form" id="comment-updating-form-{{ comment()._id }}" (ngSubmit)="save($event)">
  <div class="comment-form-fields">
    <div class="comment-header">
      <div class="comment-priority">
        <mat-icon class="icon" color="primary" [svgIcon]="form.get('priority').value" />
        <div class="priority-select">
          <mat-select formControlName="priority" focused="false" name="priority" [panelWidth]="''">
            @for (priorityOption of priorityOptions; track $index) {
              <mat-option [value]="priorityOption">
                <mat-icon color="primary" [svgIcon]="priorityOption"></mat-icon>
                {{ "comments.priority." + priorityOption | translate }}
              </mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="comment-code">
        @let formCode = form.get("code");
        <div formGroupName="code" class="comment-code-input">
          @for (codeProperty of commentService.codeProperties | keyvalue: noSort; track codeProperty.key) {
            <div>
              <div class="hint-top">{{ "comments.code." + codeProperty.key | translate }}</div>
              <input
                (input)="formCodeChanged()"
                (blur)="formChanged()"
                [class.duplicated]="formCode.hasError('duplicate')"
                matInput
                [maxLength]="codeProperty.value"
                [formControlName]="codeProperty.key" />
            </div>
          }
        </div>
        <div class="comment-code-errors">
          @if (formCode.hasError("duplicate")) {
            <mat-error>{{ "comments.code.exist" | translate }} </mat-error>
          }
          @if (firstCodeError?.key) {
            @let field = "comments.code." + firstCodeError.field | translate;
            @let typeChar = "form." + firstCodeError.typeChar | translate;
            <mat-error>
              {{
                firstCodeError.key
                  | translate
                    : {
                        field: field,
                        min: firstCodeError.min,
                        max: firstCodeError.max,
                        nbrChar: firstCodeError.nbrChar,
                        typeChar: typeChar
                      }
              }}</mat-error
            >
          }
        </div>
      </div>
    </div>
    <mat-form-field id="comment-title-{{ comment()._id }}">
      <mat-label>{{ "front.title" | translate }}</mat-label>
      <input
        matInput
        #titleInput
        name="title"
        formControlName="title"
        placeholder="{{ 'front.title' | translate }} ({{
          'validator.error.maxlength' | translate: { number: titleMaxLenght }
        }})"
        (blur)="formChanged()" />
      @let formTitle = form.get("title");
      @if (formTitle?.errors?.["required"] || formTitle?.errors?.["pattern"]) {
        <mat-error>{{ "error.title.required" | translate }}</mat-error>
      }
      @if (formTitle?.errors?.["maxlength"]) {
        <mat-error> {{ "validator.error.maxlength" | translate: { number: titleMaxLenght } }} </mat-error>
      }
    </mat-form-field>
    <div formArrayName="paragraphs" class="comment-paragraphs-form-fields">
      @for (paragraph of formParagraphs.controls; track $index; let i = $index) {
        <mat-form-field id="comment-paragraphs-{{ comment()._id }}-{{ i }}">
          @if (i === 0) {
            <mat-label>{{ "comments.paragraph" | translate }}</mat-label>
          }
          <textarea
            matInput
            [formControlName]="i"
            placeholder="{{ i === 0 ? ('comments.paragraph' | translate) : '' }}"
            name="paragraphs-{{ i }}"
            cdkTextareaAutosize
            (blur)="formChanged()">
          </textarea>
          @if (i !== 0) {
            <button
              title="remove-paragraph-{{ i }}"
              type="button"
              mat-icon-button
              matIconSuffix
              (click)="removeParagraph(i)">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          }
          @let formContent = formParagraphs.controls[i];
          @if (formContent?.hasError("required") || formContent?.hasError("pattern")) {
            <mat-error>{{ "error.content.required" | translate }}</mat-error>
          }
        </mat-form-field>
      }
    </div>
  </div>
  <div class="paragraphs-action">
    <button type="button" mat-raised-button (click)="addParagraph()">
      <mat-icon svgIcon="plus"></mat-icon>
      <span>{{ "comments.addParagraph" | translate }}</span>
    </button>
    @if (commentService.canAttachMedia) {
      <button
        mat-raised-button
        class="add-media-button"
        type="button"
        [disabled]="formMedias.controls.length >= 99"
        (click)="fileInput.click()">
        <mat-icon svgIcon="attach-file"></mat-icon>
        {{ "notes.media.add" | translate }}
      </button>
      <input [accept]="ALLOWED_MIME_TYPES_LIST" type="file" hidden #fileInput (change)="addMedia($event)" />
    }
  </div>
  @if (commentService.canAttachMedia) {
    <div>
      <ng-container *ngTemplateOutlet="mediaPanel"></ng-container>
    </div>
  }
  <div class="form-action">
    <button mat-raised-button class="cancel-button" type="button" (click)="cancel($event)">
      {{ "tocItem.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">
      {{ "tocItem.save" | translate }}
    </button>
  </div>
</form>

<ng-template #mediaPanel>
  @if (formMedias.value.length > 0) {
    <div class="info">
      <div class="key">{{ "front.attached-medias" | translate }}</div>
      <ul class="medias-panel value">
        @for (media of formMedias.value; track $index; let i = $index) {
          <li>
            <div class="media-list-item">
              <div>
                <span class="media-link" (click)="openMedia($event, media.id, media.title)">
                  {{ media.title }}
                </span>
                <span>({{ media.size | byteFormat }})</span>
              </div>
              <button type="button" title="Remove media" mat-icon-button matIconSuffix (click)="removeMedia(i)">
                <mat-icon svgIcon="delete"></mat-icon>
              </button>
            </div>
          </li>
        }
      </ul>
    </div>
  }
</ng-template>
